import { render, staticRenderFns } from "./auctionAban.vue?vue&type=template&id=fecbeac4&scoped=true"
import script from "./auctionAban.vue?vue&type=script&lang=js"
export * from "./auctionAban.vue?vue&type=script&lang=js"
import style0 from "./auctionAban.vue?vue&type=style&index=0&id=fecbeac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecbeac4",
  null
  
)

export default component.exports